import en from "@/localization/en.json";
import Image from "next/image";
import Link from "next/link";
import PropTypes from "prop-types";
import { useState } from "react";

function AppInput(props) {
  const {
    labelName,
    isFieldRequired = false,
    name = "text",
    type,
    className = "",
    forgetPasswordOption = false,
    register,
    error,
    ...inputProps
  } = props;

  const [inputType, setInputType] = useState(() => (type ? type : "text"));

  const getBorderColor = () => {
    if (error?.message) {
      return "border-[#FF4249] focus:border-[#FF4249]";
    } else {
      return "border-[#CBD0D6] focus:border-[#414E5F]";
    }
  };

  return (
    <div className={`w-full ${className}`}>
      <div className="text-grayD2 mb-[.875rem] md:mb-[1rem] flex justify-between">
        <p>
          {labelName}{" "}
          {isFieldRequired && <span className="text-[#E81E61]">*</span>}
        </p>

        {forgetPasswordOption && (
          <p className="underline cursor-pointer hover:text-[#E81E61] active:text-[#E81E61]">
            <Link href="/forget-password">
              {en["forgetPassword.forget_password"]}
            </Link>
          </p>
        )}
      </div>

      <div className="relative w-full">
        {type === "password" && (
          <div
            className="absolute top-[50%] right-[.8%] translate-x-[-50%] translate-y-[-40%] cursor-pointer"
            onClick={() =>
              setInputType(() => (inputType === "text" ? "password" : "text"))
            }
          >
            <Image
              src={`/assets/icons/${
                inputType === "text" ? "open-eye.svg" : "close-eye.svg"
              }`}
              width={20}
              height={10}
              alt="eye"
            />
          </div>
        )}

        <input
          className={`w-full border-1 focus:outline-none focus:ring-0  outline-0 h-[3.5rem] rounded-[10px] pl-[1.25rem] text-[1rem] ${getBorderColor()}`}
          {...inputProps}
          type={inputType}
          autoComplete={"off"}
          {...register(name)}
        />
      </div>
      {error?.message && (
        <p className="text-[#FF4242] text-[0.875] mt-[0.35rem] first-letter:uppercase">
          {error?.message}
        </p>
      )}
    </div>
  );
}

AppInput.propTypes = {
  labelName: PropTypes.string.isRequired,
  isFieldRequired: PropTypes.bool,
  name: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func,
};

AppInput.defaultProps = {
  onChange: () => {},
};

export default AppInput;
